import type React from 'react';

/**
 * 한글·일본어 입력기(IME)가 글자를 **조합하는 중**에 눌린 키인가.
 *
 * 한글을 치다가 Enter 를 누르면 브라우저는 조합을 끝내는 Enter 와 실제 Enter 를 따로 보낸다.
 * 첫 번째(조합 중, isComposing=true)에 반응하면 조합이 끝나기 전 값으로 동작하거나 같은 동작이 두 번 일어나,
 * 마지막 글자가 남거나 두 번 추가된다. 크롬은 조합 중 keyCode 를 229 로 주므로 둘 다 본다.
 */
export function isComposing(e: React.KeyboardEvent | KeyboardEvent): boolean {
  const native = ('nativeEvent' in e ? e.nativeEvent : e) as KeyboardEvent;
  return !!native.isComposing || native.keyCode === 229;
}

/** 조합 중이 아닌 Enter */
export function isEnter(e: React.KeyboardEvent | KeyboardEvent): boolean {
  return e.key === 'Enter' && !isComposing(e);
}
